<template>
    <div>
        <div class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center profile-header" style="min-height: 200px;">
            <b-container fluid>
                <span class="mask bg-gradient-success opacity-8"></span>
            </b-container>
        </div>
        <b-container fluid class="mt--7">
            <brand-table />
        </b-container>
    </div>
</template>

<script>
import BrandTable from "@/views/Tables/BrandTable.vue";

export default {
    components:{
        [BrandTable.name]:BrandTable
    }

}
</script>

<style>

</style>